export const videos = [
  {
    description:
      "An overview of the Teacher's Toolkit gives you a quick, easy tour and explanation of what is in the toolkit and how to navigate the pages.",
    thumbnailPath: "/img/teachers-toolkit-training/video/tt.jpg",
    url: "https://www.youtube.com/embed/DpICgeB9PJ0",
    title: "Teacher's Toolkit Tutorial",
  },
  {
    description: "This video is about how to navigate the Knowledge Bank.",
    thumbnailPath: "/img/teachers-toolkit-training/video/kb.jpg",
    url: "https://www.youtube.com/embed/Y0JDJsBrbt4",
    title: "Knowledge Bank Tutorial",
  },
  {
    description:
      "Learn all about Planet Watch and how your school can become more energy efficient.",
    thumbnailPath: "/img/teachers-toolkit-training/video/pw.jpg",
    url: "https://www.youtube.com/embed/emTTn0u4jGM",
    title: "Planet Watch Tutorial",
  },
];

export const documents = [
  {
    thumbnailPath: "/img/teachers-toolkit-training/document/tt.jpg",
    url: "/training/knowledge-bank-training-guide",
    title: "Teacher's Toolkit Guide",
  },
  {
    thumbnailPath: "/img/teachers-toolkit-training/document/kb.jpg",
    url: "/training/teachers-toolkit-training-guide",
    title: "Knowledge Bank Guide",
  },
  {
    thumbnailPath: "/img/teachers-toolkit-training/document/pw.jpg",
    url: "/training/planet-watch-training-guide",
    title: "Planet Watch Guide",
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/TeachersToolkitTraining.consts.js